import PropTypes from 'prop-types';
import { Box, Dialog, Typography, styled } from '@mui/material';
import { forwardRef, useState } from 'react';
import { CloseIcon } from '../assets/icons/icons';
import Button from './Button';
import SEMANTIC_SEARCH_RIVE from '../assets/rives/semantic_search.riv?url';
import { useRive } from '@rive-app/react-canvas';

const TryButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.blue['550'],
  border: '1px solid',
  borderColor: 'none',
  color: 'white',
  '&:hover': {
    color: theme.palette.blue['550'],
    backgroundColor: 'white',
    borderColor: theme.palette.blue['550'],
    border: '1px solid',
  },
}));

const NewSearchExplainerModal = forwardRef(({ open, onClose }, ref) => {
  const { RiveComponent } = useRive({
    src: SEMANTIC_SEARCH_RIVE,
    autoplay: true,
  });

  return (
    <Dialog ref={ref} open={open} onClose={onClose} aria-labelledby="new-search-explainer-heading">
      <Box p={2}>
        <Box p={4} sx={{ position: 'relative' }}>
          <Box sx={{ position: 'absolute', right: '0', top: '0' }}>
            <Button onClick={onClose} sx={{ minWidth: 'auto' }} aria-label="Close filters">
              <CloseIcon />
            </Button>
          </Box>
          <Typography
            id="new-search-explainer-heading"
            sx={{
              fontWeight: '500',
              fontSize: '22px',
              lineHeight: '100%',
              letterSpacing: '0%',
              textAlign: 'center',
              verticalAlign: 'middle',
            }}
            mb={2}
          >
            Introducing a smarter way to search
          </Typography>

          <Typography
            sx={{
              fontWeight: '400',
              fontSize: '14px',
              lineHeight: '150%',
              letterSpacing: '0%',
              textAlign: 'center',
            }}
          >
            Now you can search the way you think—no need to guess the right keywords. Just type what
            you’re looking for, and we’ll understand the meaning behind it. It’s faster, easier, and
            built to help you find what you need.
          </Typography>
        </Box>
        <Box textAlign="center" mb={2} sx={{ height: '200px' }}>
          <RiveComponent />
        </Box>
        <Box textAlign="center">
          <TryButton onClick={onClose} sx={{ width: '50%' }}>
            Try It Out
          </TryButton>
        </Box>
      </Box>
    </Dialog>
  );
});

NewSearchExplainerModal.displayName = 'NewSearchExplainerModal';

export default NewSearchExplainerModal;
